import styled from 'styled-components'

export const AppTaskPage = styled.div`
  text-align: left;
`
